import { StockTypeEnum } from "@/model/data/enums/StockTypeEnum";
import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";
import { GetStockImageResData } from "./GetStockImageResData";

const ENDPOINT = "/security/installation/rollsconfig/image";

export class GetStockImageCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";
    params: GetStockImageReqData = null;

    constructor(params: GetStockImageReqData) {
        super();
        this.params = { ...params };
    }

    public async execute(): Promise<GetStockImageResData> {
        let res = await this.executeCommand(null, null, this.params);
        return new GetStockImageResData(res);
    }
}

export class GetStockImageReqData {
    modelName: string;
    stockType: StockTypeEnum;
    stockIndex: number;
}
